import orderBy from "lodash/orderBy";

// Helper to check if URL is for a PDF file
const isPdfUrl = (url) => {
  if (!url) return false;
  // Check if it's a filestack URL without image transformations or has .pdf
  return url.includes('application/pdf') || url.toLowerCase().includes('.pdf');
};

export const getImageDegree = url => {
  if (!url) return 0;

  const segments = url.split("/");
  const rotateSegment = segments.find(segment => segment.startsWith("rotate="));

  if (!rotateSegment) return 0;

  const [, value] = rotateSegment.split("=");
  const [, degrees] = value.split(":");
  const rotation = parseInt(degrees, 10);

  return Number.isInteger(rotation) ? rotation : 0;
};

const degReg = /rotate=deg:\d+/g;
const defaultRotate = 0;

export const getDegree = (url, rotate) => {
  if (!url) return null;

  // Find the last slash and insert rotation after it
  const lastSlashIndex = url.lastIndexOf("/");
  const baseUrl = url.substring(0, lastSlashIndex + 1);
  const fileId = url.substring(lastSlashIndex + 1);

  return `${baseUrl}rotate=deg:${rotate}/${fileId}`;
};

export const getImage = (url, type = "height", size = 40) => {
  if (!url) return null;

  if (url.search(degReg) !== -1) {
    return url.replace("filestackcontent.com/", `filestackcontent.com/resize=${type}:${size}/`);
  }

  return getDegree(url, defaultRotate).replace(
    "filestackcontent.com/",
    `filestackcontent.com/resize=${type}:${size}/`
  );
};

export const rotateImage = (url, type = "height", size = 40, rotate = "0") => {
  if (!url) return null;

  return getDegree(url, rotate).replace(
    "filestackcontent.com/",
    `filestackcontent.com/resize=${type}:${size}/`
  );
};

export const getImageSize = (url, type = "width", size = 40) => {
  if (!url) return null;
  if (isPdfUrl(url)) return url;

  return url.replace("filestackcontent.com/", `filestackcontent.com/resize=${type}:${size}/`);
};

export const getBackgroundImage = (url, type, size) => {
  if (!url) return null;
  if (isPdfUrl(url)) return null;

  return `url(${getImageSize(url, type, size)})`;
};

export function sortImages(images) {
  return orderBy(images || [], v => v.default, "desc");
}
